import axios from 'axios';

export const getNonMemberPtInfo = ({ hspId, hspCd, acptNo, chgCnclType }) => {
  // return async () => await axios.get(`mock/nonmbr/pt-info.json`);
  return async () =>
    await axios.get(`${process.env.REACT_APP_API_DFD_SVC_URL}/dfd/api/if/web/v1/nonmbr/pt-info/${hspId}/${hspCd}`, {
      params: {
        acptNo,
        chgCnclType,
      },
    });
};

export const sendNonMemberChgCncl = ({ hspId, hspCd, acptNo, chgCnclType, ptNo, uuid }) => {
  // return async () => axios.get('mock/nonmbr/rsv-chg-cb-acpt.json');
  return async () =>
    axios.get(`${process.env.REACT_APP_API_DFD_SVC_URL}/dfd/api/if/web/v1/nonmbr/rsv-chg-cb-acpt/${hspId}/${hspCd}`, {
      params: {
        acptNo,
        chgCnclType,
        ptNo,
        uuid,
      },
    });
};
